module.exports = __webpack_public_path__ + "img/r-2-actbtn.2c32aa9b.png";